import "../styles/App.css";
import scoop from "../images/scoop.jpg";
import riftbuds from "../images/riftbuds.jpg";
import vendetta from "../images/vendetta.jpg";
import toast from "../images/toast.jpg";
import cosplay from "../images/cosplay.jpg";
import skirmish from "../images/skirmish.jpg";
import hike from "../images/hike.jpg";
import vill from "../images/vill.jpg";
import bag from "../images/bag.jpg";
import griffin from "../images/griffin.jpg";
import nacho from "../images/nacho.jpg";
import cards from "../images/cards.jpg";
import factor from "../images/factor.jpg";
import tournament from "../images/tournament.jpg";
import sehnbon from "../images/sehnbon.jpg";
import ghael from "../images/ghael.jpg";
import mf from "../images/mf.jpg";
import baddies from "../images/baddies.jpg";
import profilePic from "../images/profilepic.jpg";
import irelia from "../images/irelia.jpg";
import alanzq from "../images/alanzq.jpg";
import amy from "../images/Amy.jpg";
import wuhan from "../images/wuhan.jpg";

const formatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short", // 'short' is the default and uses K, M, B, etc.
});

const longFormatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "long", // 'short' is the default and uses K, M, B, etc.
});

interface Article {
    id: string;
    title: string;
    publication: string;
    date?: string;
    url?: string;
    imageUrl: string;
    summary: string;
    reads?: number;
    shares?: number;
}

interface CuratedTweet {
    id: string;
    text: string;
    date: string;
    url: string;
    mediaUrl?: string;
    mediaDuration?: string;
    likes?: number;
    comments?: number;
    saves?: number;
    reposts?: number;
    views?: number;
    shares?: number;
}

interface InstagramPost {
    id: string;
    url: string;
    imageUrl: string;
    alt: string;
    likes?: number;
    comments?: number;
    views?: number;
    saves?: number;
    shares?: number;
}

// Last updated: Aug 31 2026
/* Twitter stats */
const xFollowers = 346;
const xEngagement = 6700;
const xImpressions = 381100;
const xLikes = 3600;
const xSavesShares = 284 + 105;

/* Instagram stats */
const iGFollowers = 175;
const iGEngagement = 1232;
const iGImpressions = 37211;
const iGLikes = 813 + 155 + 52;
const iGSavesShares = 55 + 74;

/* Piltover Archive stats */
const pAXFollowers = 2533;
const pAIGFollowers = 549;
const pAYTFollowers = 222;
const scoopLikes = 320;
const scoopViews = 9300;
const scoopWatchTime = 487.1;
const scoopThumbnailImpressions = 58600;
const scoopNewSubscribers = 186;
const pAYTEngagement = 2 + scoopLikes;
const pAYTImpressions = 75 + scoopViews;
const paMonthlyUniqueVisitors = 1190000;

/* Combined stats */
const followers = xFollowers + iGFollowers + pAXFollowers + pAIGFollowers + pAYTFollowers;
const engagement = xEngagement + iGEngagement + pAYTEngagement;
const impressions = xImpressions + iGImpressions + pAYTImpressions;
const likes = xLikes + iGLikes;
const savesShares = xSavesShares + iGSavesShares;

const articles: Article[] = [
    {
        id: "factor",
        title: "Interview with Factor, RQ Hartford Winner and Best of Master Yi",
        publication: "Piltover Archive",
        date: "July 2026",
        url: "https://piltoverarchive.com/news/interview-with-factor",
        imageUrl: factor,
        summary: "Following his victory at Hartford, Factor breaks down battlefield selection, mulligan strategy, mind gaming the opponent, and the importance of testing bad matchups in casuals.",
    },
    {
        id: "miss fortune",
        title: "EXCLUSIVE: RQ Houston Champion Miss Fortune card sells for $100,000",
        publication: "Piltover Archive",
        date: "April 2026",
        url: "https://piltoverarchive.com/news/exclusive-miss-fortune-card-sells-for-100-000",
        imageUrl: mf,
        summary:
            "In a Piltover Archive exclusive, the broker for the $100,000 Miss Fortune, Buccaneer card sale Robert Stanley shares the process of transacting high-end deals and how this sale legitimizes Riftbound.",
    },
    {
        id: "dos and donts",
        title: "Dos and Don'ts of Tournament Play",
        publication: "Piltover Archive",
        date: "June 2026",
        url: "https://piltoverarchive.com/news/dos-and-donts-of-tournament-play",
        imageUrl: tournament,
        summary: "We gathered tips from previous RQs. In case it needs to be stated, take these dos and don'ts with a heavy dose of /s.",
    },
    {
        id: "sehnbon",
        title: "Interview with Sehnbon, Best Of Broker",
        publication: "Piltover Archive",
        date: "May 2026",
        url: "https://piltoverarchive.com/news/interview-with-sehnbon-best-of-broker",
        imageUrl: sehnbon,
        summary: "Sehnbon debunks myths about the business of buying and selling Best Of cards after each Regional Qualifier.",
    },
    {
        id: "ghaelwinds",
        title: "Interview with GhaelWinds, Houston's Best Of Yasuo",
        publication: "Piltover Archive",
        date: "April 2026",
        url: "https://piltoverarchive.com/news/interview-with-ghaelwinds-houston-s-best-of-yasuo",
        imageUrl: ghael,
        summary:
            "GhaelWinds, content creator and Best Of Yasuo Houston winner, opens up about Riftbound's growth since its “mythological era,” his time in Las Vegas, and ways in which the TCG has changed his life.",
    },
    {
        id: "baddies",
        title: 'Who are the Riftbaddies, and why are they blowing up my "For You" feed?',
        publication: "Piltover Archive",
        imageUrl: baddies,
        summary:
            "Unless you haven't yet encountered a wild Riftbaddie at Nexus Night or seen their shiny badges at RQs, this community has popped up in every daily scroll of community content, even during preview season.",
    },
];

// Add your favorite posts here
const curatedTweets: CuratedTweet[] = [
    {
        id: "tweet-7",
        text: "When the Wuhan exhibition match intro is straight out of an anime 😳",
        date: "August 30, 2026",
        url: "https://x.com/riftamy/status/2094279496757399925",
        mediaUrl: wuhan,
        mediaDuration: "0:51",
        views: 76300,
        likes: 377,
        comments: 14,
        saves: 48,
        reposts: 26,
        shares: 33,
    },
    {
        id: "tweet-1",
        text: "Hear me out: ARAM as a new Riftbound format.\n\nIt's 3-pack sealed, but you don't look, and you shuffle it all ... ",
        date: "July 9, 2026",
        url: "https://x.com/riftamy/status/2075461597720727874",
        views: 48000,
        likes: 294,
        saves: 149,
        comments: 17,
        reposts: 12,
        shares: 52,
    },
    {
        id: "tweet-2",
        text: "When you get an Ambessa pre-rift kit",
        date: "July 28, 2026",
        url: "https://x.com/riftamy/status/2082262313248448788",
        views: 24000,
        likes: 369,
        reposts: 7,
        comments: 2,
        saves: 10,
        shares: 9,
    },
    {
        id: "tweet-5",
        text: "God-tier hit in my prize pack after meeting @DisguisedToast 😱",
        date: "July 28, 2026",
        url: "https://x.com/riftamy/status/2082263508415287632",
        mediaUrl: irelia,
        mediaDuration: "0:04",
        views: 9800,
        likes: 345,
        comments: 7,
    },
    {
        id: "tweet-3",
        text: "They came, they saw, they scooped. 🍨\n\nHuge thank you to the pros for cooking ...",
        date: "August 21, 2026",
        url: "https://x.com/riftamy/status/2090857352073519344",
        mediaUrl: alanzq,
        mediaDuration: "0:18",
        views: 17000,
        likes: 101,
        comments: 2,
        saves: 15,
    },
    {
        id: "tweet-4",
        text: "Man I love riftbound",
        date: "July 27, 2026",
        url: "https://x.com/riftamy/status/2081849550596362272",
        views: 16000,
        likes: 61,
    },
    {
        id: "tweet-6",
        text: "Top 8 at today's skirmish. Long live Ahri!!!🦊",
        date: "July 11, 2026",
        url: "https://x.com/riftamy/status/2076132714760323526",
        mediaUrl: amy,
        views: 6600,
        likes: 100,
        comments: 9,
        saves: 7,
    },
    {
        id: "tweet-8",
        text: "PSA in case anyone wants to play in China: Official cards in any language are now legal for ...",
        date: "August 13, 2026",
        url: "https://x.com/riftamy/status/2088134368971964575",
        views: 4300,
        likes: 54,
        comments: 6,
        saves: 3,
    },
    {
        id: "tweet-9",
        text: "Not to moralize, but there's been an uptick in online drama. I want to take this moment to remind creators not to abuse their privileges and everyone—creators and players a...",
        date: "August 26, 2026",
        url: "https://x.com/riftamy/status/2092670058212536437",
        views: 5200,
        likes: 47,
        reposts: 8,
    },
];

const instagramPosts: InstagramPost[] = [
    {
        id: "ig-1",
        url: "https://www.instagram.com/piltover.archive/reel/DcTbS_WRR9p/",
        imageUrl: scoop,
        alt: "Instagram preview 1",
        likes: 291,
        views: 14000,
        saves: 35,
    },
    {
        id: "ig-2",
        url: "https://www.instagram.com/riftamy/reel/Db9Id97ycHs/",
        imageUrl: riftbuds,
        alt: "Instagram preview 2",
        likes: 95,
        views: 3000,
        shares: 16,
    },
    {
        id: "ig-3",
        url: "https://www.instagram.com/riftamy/p/DbfIqdDFYLh/",
        imageUrl: vendetta,
        alt: "Instagram preview 3",
        views: 724,
        likes: 63,
    },
    {
        id: "ig-4",
        url: "https://www.instagram.com/riftamy/reel/DbWaZAwyz3w/",
        imageUrl: toast,
        alt: "Instagram preview 4",
        views: 3700,
        likes: 98,
    },
    {
        id: "ig-5",
        url: "https://www.instagram.com/riftamy/reel/DbSVTLiCmE8/",
        imageUrl: cosplay,
        alt: "Instagram preview 5",
        views: 1400,
    },
    {
        id: "ig-6",
        url: "https://www.instagram.com/riftamy/p/DarhpqzlHKy/",
        imageUrl: skirmish,
        alt: "Instagram preview 6",
        likes: 47,
        views: 516,
    },
    {
        id: "ig-7",
        url: "https://www.instagram.com/riftamy/reel/DajQQ25vyrG/",
        imageUrl: hike,
        alt: "Instagram preview 4",
        views: 1900,
        likes: 67,
    },
    {
        id: "ig-8",
        url: "https://www.instagram.com/riftamy/reel/DaKPe5cikEC/",
        imageUrl: vill,
        alt: "Instagram preview 5",
        views: 4400,
        likes: 152,
        shares: 28,
    },
    {
        id: "ig-9",
        url: "https://www.instagram.com/riftamy/reel/DaGjsSqB6jv/",
        imageUrl: bag,
        alt: "Instagram preview 6",
        views: 1500,
        likes: 38,
    },
    {
        id: "ig-10",
        url: "https://www.instagram.com/riftamy/p/DaFIx40FU3u/",
        imageUrl: griffin,
        alt: "Instagram preview 10",
        views: 297,
    },
    {
        id: "ig-11",
        url: "https://www.instagram.com/riftamy/reel/DaBI9JJCf1f/",
        imageUrl: nacho,
        alt: "Instagram preview 10",
        views: 2600,
        shares: 10,
    },
    {
        id: "ig-12",
        url: "https://www.instagram.com/riftamy/p/DZs1N0zFUEW/",
        imageUrl: cards,
        alt: "Instagram preview 10",
        views: 391,
    },
];

export default function Portfolio() {
    return (
        <div className="Portfolio">
            <div className="portfolio">
                <h1>Portfolio</h1>

                <div className="intro-statement">
                    <p>
                        As a <b>games journalist</b> and <b>content strategist</b> for Piltover Archive, I cover the Riftbound pro scene and its community. My editorial work spans pro interviews,
                        news, community profiles, and satire while my video content captures behind-the-scenes moments and player personalities&mdash;with recent videos going viral within 24 hours of
                        release.
                    </p>
                    <p>
                        My background bridges editorial strategy and technical production. At Xbox, I founded, directed, and produced a weekly gaming showcase on the official Xbox Twitch channel for
                        an audience of over 800K followers. As a sponsored Twitch affiliate streamer myself, I built a community of 2,200 followers and had a regular audience of 100+ concurrent
                        viewers. Today, I channel my expertise in broadcasting and journalism into TCG content creation.
                    </p>
                </div>

                <h2>Featured Reporting</h2>

                <div className="milestone-card">
                    <div className="milestone-content">
                        <div className="milestone-label">Total Audience Reach</div>

                        <div className="milestone-number">{longFormatter.format(paMonthlyUniqueVisitors)}</div>

                        <div className="milestone-footer">
                            <svg className="milestone-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg>
                            <span>Verified unique visitors over the last 30 days</span>
                        </div>
                    </div>
                </div>
                <div className="portfolio-grid">
                    {articles.map((article) => (
                        <div className="article-item" key={article.id}>
                            {!!article.url ? (
                                <a href={article.url} target="_blank" rel="noopener noreferrer">
                                    <img src={article.imageUrl} alt={article.title} className="article-banner" />
                                </a>
                            ) : (
                                <img src={article.imageUrl} alt={article.title} className="article-banner" />
                            )}
                            {!!article.url ? (
                                <h3>
                                    <a href={article.url}>{article.title}</a>
                                </h3>
                            ) : (
                                <h3>{article.title}</h3>
                            )}
                            <p className="article-meta">
                                {article.publication}&nbsp;
                                {!!article.date && <>&mdash;&nbsp;{article.date}</>}
                            </p>
                            <p className="article-summary">{article.summary}</p>

                            {(!!article.reads || !!article.shares) && (
                                <div className="article-metrics">
                                    {!!article.reads && <span>{formatter.format(article.reads)} Reads</span>}
                                    {!!article.reads && !!article.shares && <span>&middot;</span>}
                                    {!!article.shares && <span>{article.shares} Shares</span>}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <h2>Video Content</h2>
                <div className="media-highlight">
                    <div className="video-container">
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/UFZW3Z4SUn8"
                            title="How Fast Can Pro Riftbound Players Scoop?"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        />
                    </div>
                    <div className="stats-panel">
                        <div className="stat">
                            <div className="stat-number">{formatter.format(scoopViews)}</div>
                            <div className="stat-label">Total Views</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">{formatter.format(scoopLikes)}</div>
                            <div className="stat-label">Likes</div>
                        </div>
                        {/* <div className="stat">
                            <div className="stat-number">--%</div>
                            <div className="stat-label">Engagement Rate</div>
                        </div> */}
                        <div className="stat">
                            <div className="stat-number">+{formatter.format(scoopNewSubscribers)}</div>
                            <div className="stat-label">New Subscribers</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">{formatter.format(scoopWatchTime)} hours</div>
                            <div className="stat-label">Watch Time</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">{formatter.format(scoopThumbnailImpressions)}</div>
                            <div className="stat-label">Thumbnail Impressions</div>
                        </div>
                    </div>
                </div>

                <h2>Social Media</h2>
                <div className="influence-card">
                    <div className="influence-stats">
                        <div className="stat">
                            <div className="stat-number">{formatter.format(followers)}</div>
                            <div className="stat-label">Total Followers</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">
                                <svg className="trend-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                                    <polyline points="17 6 23 6 23 12"></polyline>
                                </svg>
                                +{formatter.format(engagement)}
                            </div>
                            <div className="stat-label">Engagement (Last 3 Mos)</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">{formatter.format(impressions)}</div>
                            <div className="stat-label">Avg. Monthly Impressions</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">{formatter.format(likes)}</div>
                            <div className="stat-label">Likes</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">{formatter.format(savesShares)}</div>
                            <div className="stat-label">Saves/Shares</div>
                        </div>
                    </div>
                </div>
                <div className="influence-footer">Aggregated across RiftAmy and Piltover Archive accounts on YouTube, X, and Instagram.</div>
                <div className="social-feeds">
                    {/* Static X (Twitter) Block */}
                    <div className="feed-box">
                        <div className="social-placeholder">
                            <div className="social-header">
                                <a href="https://x.com/RiftAmy" target="_blank" rel="noopener noreferrer">
                                    <img src={profilePic} alt="@RiftAmy Profile" className="social-avatar" />
                                </a>
                                <div>
                                    <div className="social-handle">@RiftAmy</div>
                                    <div className="social-sub">X (Twitter)</div>
                                </div>
                            </div>

                            <div className="tweet-list">
                                {curatedTweets.map((tweet) => (
                                    <a href={tweet.url} target="_blank" rel="noopener noreferrer" className="tweet-item" key={tweet.id}>
                                        <div className="tweet-header-inline">
                                            <img src={profilePic} alt="Amy Profile" className="tweet-avatar-inline" />
                                            <div className="tweet-meta-inline">
                                                <span className="tweet-author-name">Amy</span>
                                                <svg className="verified-badge" viewBox="0 0 24 24" width="18" height="18" fill="#1DA1F2">
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                                <span className="tweet-dot">·</span>
                                                <span className="tweet-date-inline">{tweet.date}</span>
                                            </div>
                                        </div>

                                        <div className="tweet-content">
                                            {tweet.mediaUrl && (
                                                <div className="tweet-media-container">
                                                    <img src={tweet.mediaUrl} alt="Tweet media" className="tweet-media" />
                                                    {tweet.mediaDuration && <span className="tweet-media-duration">{tweet.mediaDuration}</span>}
                                                </div>
                                            )}
                                            <p className="tweet-text">{tweet.text}</p>
                                        </div>

                                        {(!!tweet.comments || !!tweet.likes || !!tweet.saves || !!tweet.views || !!tweet.reposts) && (
                                            <div className="tweet-metrics">
                                                {!!tweet.likes && (
                                                    <span className="tweet-stat">
                                                        <svg
                                                            width="18.75"
                                                            height="18.75"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                                        </svg>
                                                        <strong>{tweet.likes}</strong>
                                                    </span>
                                                )}
                                                {!!tweet.comments && (
                                                    <span className="tweet-stat">
                                                        <svg
                                                            width="18.75"
                                                            height="18.75"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                                        </svg>
                                                        <strong>{tweet.comments}</strong>
                                                    </span>
                                                )}
                                                {!!tweet.reposts && (
                                                    <span className="tweet-stat">
                                                        <svg
                                                            width="18.75"
                                                            height="18.75"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <path d="M17 1l4 4-4 4" />
                                                            <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                                            <path d="M7 23l-4-4 4-4" />
                                                            <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                                        </svg>
                                                        <strong>{tweet.reposts}</strong>
                                                    </span>
                                                )}
                                                {!!tweet.views && (
                                                    <span className="tweet-stat">
                                                        <svg
                                                            width="18.75"
                                                            height="18.75"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <line x1="18" y1="20" x2="18" y2="10" />
                                                            <line x1="12" y1="20" x2="12" y2="4" />
                                                            <line x1="6" y1="20" x2="6" y2="14" />
                                                        </svg>
                                                        <strong>{formatter.format(tweet.views)}</strong>
                                                    </span>
                                                )}
                                                {!!tweet.saves && (
                                                    <span className="tweet-stat">
                                                        <svg
                                                            width="18.75"
                                                            height="18.75"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                                                        </svg>
                                                        <strong>{tweet.saves}</strong>
                                                    </span>
                                                )}
                                                {!!tweet.shares && (
                                                    <span className="tweet-stat">
                                                        <svg
                                                            width="18.75"
                                                            height="18.75"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <path d="M12 4v5C5 9 2 15 2 21c2.5-6 6-7.5 10-7.5v4.5l10-7.5L12 4z" />
                                                        </svg>
                                                        <strong>{tweet.shares}</strong>
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                    </a>
                                ))}
                            </div>

                            <a href="https://x.com/RiftAmy" target="_blank" rel="noopener noreferrer" className="action-btn x-btn">
                                Follow on X
                            </a>
                        </div>
                    </div>

                    {/* Static Instagram Block */}
                    <div className="feed-box">
                        <div className="social-placeholder">
                            <div className="social-header">
                                <a href="https://instagram.com/RiftAmy" target="_blank" rel="noopener noreferrer">
                                    <img src={profilePic} alt="@RiftAmy Profile" className="social-avatar" />
                                </a>
                                <div>
                                    <div className="social-handle">@RiftAmy</div>
                                    <div className="social-sub">Instagram</div>
                                </div>
                            </div>
                            <div className="ig-grid">
                                {instagramPosts.map((post) => (
                                    <a href={post.url} target="_blank" rel="noopener noreferrer" className="ig-grid-item" key={post.id}>
                                        <img src={post.imageUrl} alt={post.alt} className="ig-grid-img" />

                                        {(!!post.comments || !!post.likes || !!post.views || !!post.shares || !!post.saves) && (
                                            <div className="ig-overlay">
                                                {!!post.likes && (
                                                    <span className="ig-stat">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                                        </svg>
                                                        {post.likes}
                                                    </span>
                                                )}
                                                {!!post.comments && (
                                                    <span className="ig-stat">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                                                        </svg>
                                                        {post.comments}
                                                    </span>
                                                )}
                                                {!!post.views && (
                                                    <span className="ig-stat">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                                        </svg>
                                                        {formatter.format(post.views)}
                                                    </span>
                                                )}
                                                {!!post.saves && (
                                                    <span className="ig-stat">
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z" />
                                                        </svg>
                                                        {post.saves}
                                                    </span>
                                                )}
                                                {!!post.shares && (
                                                    <span className="ig-stat">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                                                        </svg>
                                                        {post.shares}
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                    </a>
                                ))}
                            </div>
                            <a href="https://instagram.com/RiftAmy" target="_blank" rel="noopener noreferrer" className="action-btn ig-btn">
                                View on Instagram
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
